import {IManager} from "./Manager";
import AppManager from "./AppManager";
import ApiManager from "./api/ApiManager";
import ConfigManager from "./config/ConfigManager";
import NavigationManager from "./navigation/NavigationManager";
import StorageManager from "./StorageManager";
import StorageDataManager from "./StorageDataManager";
import UserManager from "./user/UserManager";
import FileManager from "./FileManager";
import InteractionManager from "./InteractionManager";
import UiManager from "./UiManager";
import ViewManager from "./view/ViewManager";
import ViewConfig from "./../../tsx/config/ViewConfig";
import PostManager from "./post/PostManager";
import LocationManager from "../../module/osm/location/LocationManager";
import GeneralManager from "./GeneralManager";

export const managerConfig:IManager =
{
    app: new AppManager(),
    api: new ApiManager(),
    config: new ConfigManager(),
    navigation: new NavigationManager(),
    storage: new StorageManager(),
    storageData: new StorageDataManager(),
    user: new UserManager(),
    post: new PostManager(),
    file: new FileManager(),
    general: new GeneralManager(),
    interaction: new InteractionManager(),
    location: new LocationManager(),
    ui: new UiManager(),
    view: new ViewManager(new ViewConfig())

}